import type { BoundActions, GenericContainerComponent, HookFunction } from 'react-sweet-state';
import { createContainer, createHook, createStore } from 'react-sweet-state';
import { v4 as uuid } from 'uuid';

export const NativeCollabPresenceStateContainer: GenericContainerComponent<unknown> =
	createContainer();

const Store = createStore({
	containedBy: NativeCollabPresenceStateContainer,
	initialState: {
		presenceId: '',
	},
	actions: {},
	handlers: {
		onInit:
			() =>
			({ setState }) => {
				setState({
					presenceId: uuid(),
				});
			},
	},
});

export const useNativeCollabPresenceState: HookFunction<
	{
		presenceId: string;
	},
	BoundActions<
		{
			presenceId: string;
		},
		{}
	>,
	void
> = createHook(Store);
